import React from 'react';
import { Button, Image } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';

const PlayButton = ({ onClick, ariaLabel }: { onClick: () => void; ariaLabel: string }) => (
	<Button
		onClick={onClick}
		className="play-button bg-transparent border-0 rounded-circle p-0"
		aria-label={ariaLabel}
	>
		<Image src={IMAGE_PATHS.PlayIcon} className="w-100" alt="player-icon" loading="lazy" />
	</Button>
);

export default PlayButton;
